import { createFileRoute, redirect } from "@tanstack/react-router";
import { redirectIfModuleDisabled } from "@/lib/module-guards";

export const Route = createFileRoute("/_marketing/developers/")({
	beforeLoad: () => {
		redirectIfModuleDisabled("docs", "/");
		throw redirect({ to: "/docs", replace: true });
	},
});
